// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/mutation-save.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Properties_Content_Content($id: uuid!, $properties: jsonb!) {
  update_apps_app_companies_by_pk(
    pk_columns: { id: $id }
    _append: { metadata: { properties: $properties } }
  ) {
    id
    properties: metadata(path: "properties")
  }
}

`